import React from "react";
import Col from "react-bootstrap/Col";

import "../streamLayout.css";
interface CameraProps {
  camera: {
    name: string;
  };
}

export function Camera(props: CameraProps) {
  let camera = props.camera;

  const onStreamDragStart = (ev: React.DragEvent) => {
    ev.dataTransfer.clearData();
    ev.dataTransfer.setData("text/plain", camera.name);
  };

  return (
    <Col md={3} lg={2} xl>
      <div
        draggable
        key={camera.name}
        onDragStart={(ev) => onStreamDragStart(ev)}
        className="camera-container text-center"
      >
        {camera.name}
      </div>
    </Col>
  );
}
